import { TeamBadge } from '../../../components/TeamBadge';
import { cn } from '../../../lib/cn';

export function OverlappingTeamBadges({
  homeCode,
  awayCode,
  homeLogo,
  awayLogo,
  homeTeam,
  awayTeam,
  flag
}: {
  homeCode: string;
  awayCode: string;
  homeLogo?: string | null;
  awayLogo?: string | null;
  homeTeam: string;
  awayTeam: string;
  flag: boolean;
}) {
  const ringClass = flag
    ? 'shadow-[inset_0_0_0_1px_rgba(0,0,0,0.12),0_2px_5px_-2px_rgba(0,0,0,0.3)]'
    : 'shadow-[0_2px_5px_-2px_rgba(0,0,0,0.18)]';
  return (
    <div className="flex shrink-0 items-center">
      <TeamBadge
        code={homeCode}
        logo={homeLogo}
        name={homeTeam}
        flag={flag}
        sizeClass="h-[25px] w-[25px]"
        roundedClass="rounded-[6px]"
        textClass="text-[7px]"
        className={ringClass}
      />
      <TeamBadge
        code={awayCode}
        logo={awayLogo}
        name={awayTeam}
        flag={flag}
        sizeClass="h-[25px] w-[25px]"
        roundedClass="rounded-[6px]"
        textClass="text-[7px]"
        className={cn('-ml-2', ringClass)}
      />
    </div>
  );
}
